import { __TYPE__, Staff } from '../models';

export class StaffUtils {
  public static getMapOfIdAndStaff(staffs: Staff[]): Map<number, Staff> {
    return new Map<number, Staff>(staffs?.map((staff) => [staff.id, staff]));
  }

  public static transformStaffForBackend(staff: Staff): Staff {
    return {
      ...staff,
      __type__: staff?.__type__ || __TYPE__.BASIC_STAFF,
    };
  }

  public static transformStaffListForFrontend(staffs: Staff[]): Staff[] {
    if (!staffs?.length) {
      return staffs;
    }

    staffs.sort((s1, s2) => {
      if (s1.id < s2.id) {
        return -1;
      }
      if (s1.id > s2.id) {
        return 1;
      }
      return 0;
    });

    return staffs;
  }
}
